import { css } from '@emotion/react';
import { Button, Colors, Typography } from '@zapier/design-system';

import { mediaQueries, urls, useSize } from '@zapier/identity-utils';
import { useMemo } from 'react';

const rootStyle = css`
  display: grid;
  grid-gap: 15px;
  ${mediaQueries.desktop} {
    grid-gap: 20px;
  }
`;

const titleStyle = css`
  ${Typography.pageHeader7}
  color: ${Colors.neutral800};
  ${mediaQueries.desktop} {
    ${Typography.pageHeader5}
  }
`;

const descriptionStyle = css`
  ${Typography.paragraph3}
  color: ${Colors.neutral700};
  ${mediaQueries.desktop} {
    ${Typography.paragraph1Short}
  }
`;

const buttonGridStyles = css`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, min-content));
`;

export function CompaniesIntroPromo() {
  const size = useSize();
  const buttonText = useMemo(() => {
    if (size === 'small') {
      return 'Try it out';
    }

    return 'Try our Team or Company plan';
  }, [size]);

  return (
    <div css={rootStyle}>
      <h3 css={titleStyle}>Ready to scale your business?</h3>
      <p css={descriptionStyle}>
        Easily collaborate with your team with shared Zaps and app connections,
        a centralized login, and more
      </p>
      <div css={buttonGridStyles}>
        <Button
          hasShadow={true}
          href={urls.TEAMS_COMPANIES_PLAN_URL}
          size="small"
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
}
